<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title> Order Details : {{ orderID }} </v-card-title>
              </v-card>
              <v-card class="mb-4 pb-12">
                <v-card-title> Customer Details </v-card-title>
                <div class="pl-6 pr-6">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="5" class="item_title text-left">
                          <span>Customer Name</span>
                        </v-col>
                        <v-col cols="7">
                          <span class="item_value text-center">{{
                            fullname
                          }}</span>
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="5" class="item_title text-left">
                          <span>Order Date</span>
                        </v-col>
                        <v-col cols="7">
                          <span class="item_value">{{
                            formatDate(purchase.create_date)
                          }}</span>
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="5" class="item_title text-left">
                          <span>Phone</span>
                        </v-col>
                        <v-col cols="7">
                          <span
                            class="item_value"
                            v-if="customerDetails.phone"
                            >{{ customerDetails.phone }}</span
                          >
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="4" md="5" class="item_title text-left">
                          <span>Email</span>
                        </v-col>
                        <v-col cols="8" md="7">
                          <span
                            class="item_value"
                            v-if="customerDetails.customerid"
                            >{{ customerDetails.customerid.email }}</span
                          >
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="4" md="5" class="item_title text-left">
                          <span>Total Amount</span>
                        </v-col>
                        <v-col cols="8" md="7">
                          <span class="item_value" v-if="purchase.totalAmount"
                            >Rs.{{ filterValue(purchase.totalAmount) }}</span
                          >
                          <span v-else class="item_value">-</span>
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-row>
                        <v-col cols="4" md="5" class="item_title text-left">
                          <span>Payment Status</span>
                        </v-col>
                        <v-col cols="8" md="7">
                          <span
                            class="item_value"
                            v-if="purchase.paymentStatus"
                            >{{ purchase.paymentStatus }}</span
                          >
                          <span v-else class="item_value">-</span>
                        </v-col>
                      </v-row>
                      <hr />
                    </v-col>
                  </v-row>
                </div>

                <div>
                  <v-card-title> Product Details</v-card-title>
                </div>

                <div>
                  <v-layout wrap justify-start v-if="products.length > 0">
                    <template v-for="(item, i) in products">
                      <v-flex xs12 xl11 :key="item._id" pr-lg-6 pr-xl-0 pa-2>
                        <v-layout wrap py-2>
                          <v-flex xs12 sm12 md12 lg6>
                            <v-layout wrap justify-start>
                              <v-flex xs12 sm3 md3 lg2 xl2 pr-md-2>
                                <v-img
                                  :src="
                                    baseURL +
                                    '/file/get/' +
                                    item.productId.photos[0]
                                  "
                                  aspect-ratio="1"
                                  contain
                                  height="100px"
                                  router-link
                                  :to="'/productDetails/' + item.productId._id"
                                ></v-img>
                              </v-flex>
                              <v-flex xs12 sm9 md9 lg9 xl9>
                                <v-layout wrap justify-center fill-height>
                                  <v-flex xs12>
                                    <v-layout wrap justify-start>
                                      <v-flex lg8 text-left>
                                        <router-link
                                          :to="
                                            '/productDetails/' +
                                            item.productId._id
                                          "
                                          style="text-decoration: none"
                                        >
                                          <span
                                            style="
                                              font-size: 16px;
                                              color: #000000;
                                            "
                                          >
                                            {{ item.name }}
                                          </span>
                                        </router-link>
                                      </v-flex>
                                      <v-flex lg4>
                                        <a
                                          :href="
                                            baseURL +
                                            '/order/invoice/pdf/?orderid=' +
                                            $route.params.id +
                                            '&productid=' +
                                            item._id
                                          "
                                          target="_blank"
                                          style="text-decoration: none"
                                        >
                                          <v-icon small color="primary"
                                            >mdi-receipt</v-icon
                                          >
                                          <span
                                            color="primary"
                                            style="font-size: 16px"
                                          >
                                            Invoice
                                          </span>
                                        </a>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 align-self-end>
                                    <v-layout wrap justify-start>
                                      <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                            >
                                              Discount
                                            </span>
                                          </v-flex>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                font-size: 16px;
                                                color: #3bc17a;
                                              "
                                            >
                                              {{ item.discount }}%
                                            </span>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                      <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                            >
                                              Price
                                            </span>
                                          </v-flex>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                font-size: 16px;
                                              "
                                            >
                                              Rs.{{ filterValue(item.price) }}
                                            </span>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                 
                                      <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left lg12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                              >Offer Price</span
                                            >
                                          </v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                          <v-flex text-left lg12>
                                            <span
                                              style="
                                                font-family: poppins;

                                                font-size: 16px;
                                              "
                                              >Rs.{{
                                                filterValue(item.offerPrice)
                                              }}</span
                                            >
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                           <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                            >
                                             Quantity
                                            </span>
                                          </v-flex>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                font-size: 16px;
                                              "
                                            >
                                            {{
                                                item.quantity
                                              }}
                                            </span>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                           <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                            >
                                              Tax
                                            </span>
                                          </v-flex>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                font-size: 16px;
                                              "
                                            >
                                              Rs.{{
                                                filterValue(item.productTax)
                                              }}
                                            </span>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                      
                                      <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left lg12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                              >Delivery Charge</span
                                            >
                                          </v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                          <v-flex text-left lg12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                color: red;
                                                font-size: 16px;
                                              "
                                              >{{
                                                item.productDeliveryCharge
                                              }}</span
                                            >
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                           <v-flex xs6 sm3 md3 lg3 xl3>
                                        <v-layout wrap>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                color: #8d8d8d;
                                                font-family: poppins;
                                                font-size: 12px;
                                              "
                                            >
                                             Total
                                            </span>
                                          </v-flex>
                                          <v-flex text-left xs12>
                                            <span
                                              style="
                                                font-family: poppins;
                                                font-size: 16px;
                                              "
                                            >
                                              Rs.{{
                                                filterValue(item.productTotalAmount)
                                              }}
                                            </span>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex
                                text-left
                                xs1
                                text-center
                                hidden-md-and-down
                              >
                                <v-divider vertical></v-divider>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex text-left xs12 md12 lg6>
                            <v-layout wrap justify-space-between fill-height>
                              <v-flex sm4 md3 lg4 xl4>
                                <v-layout wrap>
                                   <v-flex xs6 sm12>
                                    <span
                                      style="
                                        color: #8d8d8d;
                                        font-family: poppins;
                                        font-size: 12px;
                                      "
                                    >
                                      Item Ordered on
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12>
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 12px;
                                        color: #000000;
                                      "
                                    >
                                      {{
                                        formatDate(item.track_dateTime.ordered)
                                      }}
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12>
                                    <span
                                      style="
                                        color: #8d8d8d;
                                        font-family: poppins;
                                        font-size: 12px;
                                      "
                                    >
                                      Order Status
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12 text-left align-self-start>
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 16px;
                                        color: #3bc17a;
                                      "
                                    >
                                      {{ item.productOrderStatus }}
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12 align-self-end pt-2>
                                    <v-select
                                      v-model="item.deliveryStatus"
                                      :items="status"
                                      item-text="text"
                                      item-value="value"
                                      label="Delivery Status"
                                      size
                                      dense
                                      outlined
                                      @change="
                                        setOrderstatus(
                                          item.deliveryStatus,
                                          item._id,
                                          item.sellerId.uid
                                        )
                                      "
                                    >
                                    </v-select>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                                 
                              <v-flex sm5 md3 lg4 xl4 text-left>
                                <v-layout wrap pl-4>
                                  <v-flex xs6 sm12>
                                    <span
                                      style="
                                        color: #8d8d8d;
                                        font-family: poppins;
                                        font-size: 12px;
                                      "
                                    >
                                      Delivery Address
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12 text-left align-self-center>
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ purchase.deliveryAddress.firstName }}
                                      {{
                                        purchase.deliveryAddress.lastName
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ purchase.deliveryAddress.address }},
                                      {{
                                        purchase.deliveryAddress.landmark
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ purchase.deliveryAddress.city }},
                                      {{
                                        purchase.deliveryAddress.state
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{
                                        purchase.deliveryAddress.pincode
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      Contact:
                                      {{ purchase.deliveryAddress.mobile }}
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex sm5 md3 lg4 xl4 text-left>
                                <v-layout wrap pl-4>
                                  <v-flex xs6 sm12>
                                    <span
                                      style="
                                        color: #8d8d8d;
                                        font-family: poppins;
                                        font-size: 12px;
                                      "
                                    >
                                      Seller Details
                                    </span>
                                  </v-flex>
                                  <v-flex xs6 sm12 text-left align-self-center>
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ item.sellerId.contactPerson}}
                                       </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ item.sellerId.email}}
                                       </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{ item.sellerId.place }},
                                      {{
                                        item.sellerId.city
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      {{
                                        item.sellerId.pincode
                                      }} </span
                                    ><br />
                                    <span
                                      style="
                                        font-family: poppins;
                                        font-size: 14px;
                                        color: black;
                                      "
                                    >
                                      Shop Name:
                                      {{ item.sellerId.shopName }}
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 xl11 :key="i" py-4>
                        <v-divider></v-divider>
                      </v-flex>
                    </template>
                  </v-layout>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
// import pdf from 'vue-pdf'
export default {
  // components: {
  //   pdf
  // },
  data() {
    return {
      purchase: {},
      orderID: null,
      fullname: null,
      customerDetails: null,
      deliverydate: null,
      deliverytime: null,
      products: [],
      receipts: [],
      product: [],
      deliveryStatus: null,
      productdetails: [],
      details: [],
      search: "",
      count: 10,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      time: null,
      time3: null,
      menu2: false,
      appLoading: false,
      ServerError: false,
      userStatus: null,
      userRole: localStorage.getItem("role"),
      headers: [
        { text: " Productname", value: "name" },
        { text: "Seller", value: "shopName" },
        { text: "Quantity", value: "Quantity" },
        { text: "MRP", value: "Price" },
        { text: "Offer Price", value: "offerPrice" },
        { text: "Total Price", value: "tPrice" },
        // { text: "Shipping Charge", value: "charge" },
      ],
      receipt: [
        // { key: "accountcreateat", label: "Created on", sortable: false },
        { value: "Products", text: "Products", tdClass: "tdwidth" },
        { value: "Seller", text: "Seller " },
        { value: "Receipt", text: "Receipt" },
      ],
      status: [
        { value: "ordered", text: "Ordered" },
        { value: "packed", text: "Packed" },
        { value: "shipped", text: "Shipped" },
        { value: "outfordelivery", text: "Out for Delivery" },
        { value: "delivered", text: "Delivered" },
        // { value: "Return", text: "Return" },
      ],
      Status: null,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
    };
  },
  beforeMount() {
    this.getPurchasedetails();
  },
  watch: {
    itemsPerPage: function () {
      //   this.getPurchasedetails();
    },
  },
  methods: {
    filterValue(value) {
      return Number(value).toLocaleString();
    },
    prevpage() {
      if (this.page > 1) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page--;
        this.getPurchasedetails();
        // } else {
        //   this.page--;
        //   this.getPurchasedetails();
        // }
      }
    },
    nextpage() {
      if (this.page < this.totalpages) {
        // if (this.searchKey || this.company || this.address || this.phone || this.email || this.nature || this. customerID) {
        this.page++;
        this.getPurchasedetails();
        // } else {
        //   this.page++;
        //   this.getPurchasedetails();
        // }
      }
    },
    getPurchasedetails() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/order/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.purchase = response.data.data;
          this.orderID = this.purchase.orderID;
          if (this.purchase.uid) this.customerDetails = this.purchase.uid;
          if (this.purchase.products) this.products = this.purchase.products;
          // console.log(this.products);
          if (this.customerDetails.customerid)
            this.fullname =
              this.customerDetails.customerid.firstName +
              " " +
              this.customerDetails.customerid.lastName;
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },

    setOrderstatus(Status, productId, sellerId) {
      // console.log(sellerId +' '+productId)
      axios({
        url: "/admin/seller/ordered/product/status/change",
        method: "POST",

        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          sellerId: sellerId,
          orderid: this.$route.params.id,
          productid: productId,
          productOrderStatus: Status,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Order status Updated!";
            this.showsnackbar = true;

            this.getPurchasedetails();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style >
.item_title {
  font-weight: bold;
  font-size: 12px;
}
.item_value {
  font-size: 14px;
  color: Black;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(28, 133, 219, 0.05);
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>



